/* ==========================================================================
   Figuren Collection Board
   Filterleiste für /collections/figuren — Verfügbarkeit, Serie, Figurenreihe.

   Warum clientseitig und nicht über Shopify-Facetten:
   Die Produktdaten tragen weder Serie noch Reihe. `vendor` ist bei fast allen
   Produkten "animeboy" bzw. "animeboy preorder", `productType` ist durchgängig
   leer und Tags sind uneinheitlich ("onepiece", "newlook15", "mj", "pre-order").
   Die Titel folgen dagegen sehr zuverlässig dem Muster
   "Serie – Figurenreihe – Charakter Figur". Beides wird deshalb aus dem Titel
   abgeleitet, genauso wie in bbx-collection-board.js und kuji-collection-board.js.

   Zweites Dropdown ist absichtlich die FIGURENREIHE, nicht der Hersteller:
   nahezu alle Figuren im Sortiment kommen von Banpresto/Bandai Spirits, ein
   Hersteller-Filter hätte also nur eine sinnvolle Option. Sammler suchen
   ohnehin nach der Reihe — "Grandista", "Ichibansho", "DXF", "King of Artist".

   Kernprinzip (wie bei Kuji und Blindbox): Karten werden NIE aus
   #product-grid entfernt, nur per Klasse markiert und über CSS `order`
   sortiert. Sonst brechen Load-More, der Filter-Drawer und die
   Section-Render-Sortierung des Themes.
   ========================================================================== */

(function () {
  'use strict';

  var ALL = '__all__';

  /* Reihenfolge = Priorität, der erste Treffer gewinnt.
     One Piece steht vor Dragon Ball, weil "Monkey D. Dragon" sonst als
     Dragon Ball einsortiert würde. Das Muster fängt zugleich die
     Schreibweise "Dragonball" ab, die in drei Titeln steht.
     Serien ohne Bestand erscheinen nicht im Dropdown — die Liste darf
     deshalb auf künftige Releases vorgreifen. */
  var SERIES = [
    { label: 'One Piece', re: /one\s*piece/ },
    { label: 'Dragon Ball', re: /dragon\s*ball/ },
    { label: 'Naruto', re: /naruto/ },
    { label: 'Demon Slayer', re: /demon\s*slayer|kimetsu/ },
    { label: 'Jujutsu Kaisen', re: /jujutsu/ },
    { label: 'Chainsaw Man', re: /chainsaw\s*man/ },
    { label: 'Detective Conan', re: /detective\s*conan|\bconan\b/ },
    { label: 'Sakamoto Days', re: /sakamoto\s*days/ },
    { label: 'Dandadan', re: /dandadan|dan\s*da\s*dan/ },
    { label: 'Frieren', re: /frieren/ },
    { label: 'My Hero Academia', re: /my\s*hero\s*academia|boku\s*no\s*hero/ },
    { label: 'Attack on Titan', re: /attack\s*on\s*titan|shingeki/ },
    { label: 'Tokyo Revengers', re: /tokyo\s*revengers/ },
    { label: 'Spy × Family', re: /spy\s*[×x]\s*family/ },
    { label: 'Hunter × Hunter', re: /hunter\s*[×x]\s*hunter/ },
    { label: 'Bleach', re: /bleach/ },
    { label: 'Haikyu!!', re: /haikyu/ },
    { label: 'Pokémon', re: /pok[eé]mon/ },
    { label: 'Blue Lock', re: /blue\s*lock/ },
    { label: 'Solo Leveling', re: /solo\s*leveling/ },
    { label: 'Kaiju No. 8', re: /kaiju\s*no\.?\s*8/ },
    { label: 'Oshi no Ko', re: /oshi\s*no\s*ko/ },
    { label: 'Evangelion', re: /evangelion/ },
    { label: 'Yu-Gi-Oh!', re: /yu-?gi-?oh/ },
    { label: 'Digimon', re: /digimon/ },
    { label: "JoJo's Bizarre Adventure", re: /jojo/ },
    { label: 'Black Clover', re: /black\s*clover/ },
    { label: 'Fairy Tail', re: /fairy\s*tail/ },
    { label: 'Inuyasha', re: /inuyasha/ },
    { label: 'Gintama', re: /gintama/ },
    { label: 'Overlord', re: /overlord/ },
    { label: 'Wind Breaker', re: /wind\s*breaker/ },
    { label: "Hell's Paradise", re: /hell'?s\s*paradise|jigokuraku/ },
    { label: 'Vinland Saga', re: /vinland/ },
    { label: 'Mob Psycho 100', re: /mob\s*psycho/ },
    { label: 'Re:Zero', re: /re\s*:\s*zero/ },
    { label: 'Sword Art Online', re: /sword\s*art\s*online/ },
    { label: 'Fate', re: /fate\s*\/|fate\s*grand\s*order/ }
  ];

  /* Figurenreihen. Auch hier gilt: spezifisch vor allgemein.
     "Ichibansho" und "Ichiban Kuji" sind zwei verschiedene Dinge — deshalb
     nie auf /ichiban/ allein prüfen. */
  var LINES = [
    { label: 'Grandista', re: /grandista/ },
    { label: 'Ichibansho', re: /ichibansho|ichiban[\s-]sho\b/ },
    { label: 'Ichiban Kuji', re: /ichiban\s*kuji/ },
    { label: 'Master Stars Piece', re: /master\s*stars?\s*piece/ },
    { label: 'DXF – The Grandline Series', re: /\bdxf\b/ },
    { label: 'King of Artist', re: /king\s*of\s*artist/ },
    { label: 'Match Makers', re: /match\s*makers/ },
    { label: 'Vibration Stars', re: /vibration\s*stars/ },
    { label: 'Premium Figure', re: /premium\s*(figure|\[)/ },
    { label: 'XXRAY / Wanted Series', re: /xxray|wanted\s*series/ },
    { label: 'Maximatic', re: /maximatic/ },
    { label: 'Blood of Saiyans', re: /blood\s*of\s*saiyans/ },
    { label: 'Clearise', re: /clearise/ },
    { label: 'Solid Edge Works', re: /solid\s*edge\s*works/ },
    { label: 'G×Materia', re: /g\s*[×x]\s*materia/ },
    { label: 'WCF – World Collectable', re: /\bwcf\b|world\s*collectable/ },
    { label: 'Sofvimates', re: /sofvimates/ },
    { label: 'Masterlise', re: /masterlise/ },
    { label: 'Dokkan Battle', re: /dokkan/ },
    { label: 'Glitter & Glamours', re: /glitter\s*&?\s*glamours/ },
    { label: 'Battle Record Collection', re: /battle\s*record/ },
    { label: 'Manhood', re: /manhood/ },
    { label: 'Effectreme', re: /effectreme/ },
    { label: 'Noodle Stopper', re: /noodle\s*stopper/ },
    { label: 'Luminasta', re: /luminasta/ },
    { label: 'PM Chokonose', re: /chokonose/ },
    { label: 'Figuarts ZERO', re: /figuarts/ },
    { label: 'FL Figure', re: /\bfl\s*figure\b/ },
    { label: 'Q Posket', re: /q\s*posket|qposket/ },
    { label: 'Nendoroid', re: /nendoroid/ },
    { label: 'Pop Up Parade', re: /pop\s*up\s*parade/ },
    { label: 'Figma', re: /\bfigma\b/ },
    { label: 'Look Up', re: /look\s*up/ },
    { label: 'Scultures', re: /scultures/ },
    { label: 'Figure Colosseum', re: /colosseum/ },
    { label: 'Memorial Vignette', re: /memorial\s*vignette/ },
    { label: 'Chibi Masters', re: /chibi\s*masters/ },
    { label: 'Relax Time', re: /relax\s*time/ },
    { label: 'Espresto', re: /espresto/ },
    { label: 'Grandline Men', re: /grandline\s*men/ },
    { label: 'Grandline Lady', re: /grandline\s*lady/ }
  ];

  function match(list, haystack) {
    for (var i = 0; i < list.length; i++) {
      if (list[i].re.test(haystack)) return list[i].label;
    }
    return '';
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function Board(tools) {
    this.tools = tools;
    this.board = tools.querySelector('[data-fgr-board]');
    this.grid = document.getElementById('product-grid');
    /* Nicht document.querySelector('.collection') — die subcollections-Section
       bringt einen eigenen .collection-Container mit und steht im DOM davor.
       Die Leiste landete dadurch über den Kategorie-Kacheln statt über dem Grid. */
    this.collection = this.grid ? this.grid.closest('.collection') : null;
    this.view = 'live';
    this.serie = ALL;
    this.line = ALL;
    this.items = [];
    this.labels = {
      allSeries: tools.getAttribute('data-all-series-label') || 'Alle Serien',
      allLines: tools.getAttribute('data-all-lines-label') || 'Alle Reihen',
      empty: tools.getAttribute('data-empty-text') || 'Dazu haben wir gerade keine Figur.',
      reset: tools.getAttribute('data-reset-label') || 'Filter zurücksetzen'
    };
  }

  Board.prototype.init = function () {
    if (!this.board || !this.grid || !this.collection) return;

    this.scan();
    if (!this.items.length) return;

    document.documentElement.classList.add('fgr-on');
    this.mount();
    this.buildSelects();
    this.bind();
    this.apply();
    this.watch();
  };

  /* Karten einlesen. Verfügbarkeit kommt aus .price--sold-out — das setzt
     das Theme serverseitig und ist damit verlässlicher als ein Badge-Text. */
  Board.prototype.scan = function () {
    var kids = this.grid.children;
    this.items = [];

    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (!el.classList || !el.classList.contains('grid-item')) continue;

      var link = el.querySelector('a[href*="/products/"]');
      var heading = el.querySelector('.card-heading');
      var title = (heading ? heading.textContent : link ? link.textContent : '') || '';
      title = title.replace(/\s+/g, ' ').trim();
      if (!title) continue;

      var hay = title.toLowerCase();
      var sold = !!el.querySelector('.price--sold-out, .badge.sold-out');

      el.classList.toggle('fgr-item--sold', sold);

      this.items.push({
        el: el,
        sold: sold,
        serie: match(SERIES, hay),
        line: match(LINES, hay)
      });
    }
  };

  /* Die Leiste muss in .collection hängen, damit sie über der ganzen
     Grid-Höhe kleben kann. Die Tools-Section selbst ist dafür zu niedrig. */
  Board.prototype.mount = function () {
    var wrap = document.createElement('div');
    wrap.className = 'fgr-sticky';
    if (this.tools.getAttribute('data-sticky') === 'true') {
      wrap.classList.add('is-sticky');
    }

    var anchor = this.grid;
    while (anchor && anchor.parentElement !== this.collection) {
      anchor = anchor.parentElement;
    }

    wrap.appendChild(this.board);
    this.board.hidden = false;

    if (anchor) {
      this.collection.insertBefore(wrap, anchor);
    } else {
      this.collection.insertBefore(wrap, this.collection.firstChild);
    }

    this.empty = document.createElement('li');
    this.empty.className = 'fgr-empty';
    this.empty.hidden = true;
    this.empty.innerHTML =
      '<p class="fgr-empty__text"></p>' +
      '<button type="button" class="fgr-empty__btn"></button>';
    this.empty.querySelector('.fgr-empty__text').textContent = this.labels.empty;
    this.empty.querySelector('.fgr-empty__btn').textContent = this.labels.reset;
    this.grid.appendChild(this.empty);
  };

  /* Die Kollektion hat mehr Produkte als eine Grid-Seite fasst (130 gegen
     120), der Rest kommt per "Mehr anzeigen" nach. Ohne diesen Beobachter
     wären die nachgeladenen Karten unsichtbar für Filter und Zähler — bei
     Blindbox passte alles auf eine Seite, hier nicht. */
  Board.prototype.watch = function () {
    if (typeof MutationObserver !== 'function') return;

    var self = this;
    var pending = false;

    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () {
        pending = false;
        self.refresh();
      }, 0);
    });

    obs.observe(this.collection, { childList: true, subtree: true });
  };

  Board.prototype.refresh = function () {
    /* Load-More kann das Grid komplett ersetzen — Referenz neu auflösen. */
    var grid = document.getElementById('product-grid');
    if (grid && grid !== this.grid) this.grid = grid;

    var before = this.items.length;
    this.scan();

    if (this.empty.parentElement !== this.grid) this.grid.appendChild(this.empty);
    if (this.items.length === before) return;

    this.buildSelects();
    this.apply();
  };

  /* Optionen aus dem tatsächlichen Bestand — nie eine leere Serie anbieten */
  Board.prototype.options = function (key, allLabel) {
    var counts = {};
    var order = key === 'serie' ? SERIES : LINES;

    this.items.forEach(function (item) {
      var v = item[key];
      if (!v) return;
      counts[v] = (counts[v] || 0) + 1;
    });

    var out = [{ value: ALL, text: allLabel, n: this.items.length }];
    order.forEach(function (entry) {
      if (counts[entry.label]) {
        out.push({ value: entry.label, text: entry.label, n: counts[entry.label] });
      }
    });
    return out;
  };

  Board.prototype.buildSelects = function () {
    var self = this;

    [
      { key: 'serie', all: this.labels.allSeries },
      { key: 'line', all: this.labels.allLines }
    ].forEach(function (cfg) {
      var root = self.board.querySelector('[data-fgr-select="' + cfg.key + '"]');
      if (!root) return;

      var panel = root.querySelector('[data-fgr-select-panel]');
      var opts = self.options(cfg.key, cfg.all);

      /* Nur ein Eintrag heißt: es gibt nichts zu filtern */
      if (opts.length < 2) {
        root.hidden = true;
        return;
      }
      root.hidden = false;

      /* Beim Neuaufbau nach dem Nachladen muss die aktive Auswahl erhalten
         bleiben — sonst springt das Dropdown auf "Alle" zurück, obwohl
         weiter gefiltert wird. Fällt die gewählte Option weg, wird sie
         sauber auf ALL zurückgesetzt. */
      var current = self[cfg.key];
      var stillThere = opts.some(function (o) { return o.value === current; });
      if (!stillThere) current = self[cfg.key] = ALL;

      panel.innerHTML = '';
      opts.forEach(function (opt) {
        var on = opt.value === current;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fgr-opt' + (on ? ' is-active' : '');
        btn.setAttribute('role', 'option');
        btn.setAttribute('data-value', opt.value);
        btn.setAttribute('aria-selected', on ? 'true' : 'false');
        btn.innerHTML =
          '<span class="fgr-opt__text"></span><span class="fgr-opt__n"></span>';
        btn.querySelector('.fgr-opt__text').textContent = opt.text;
        btn.querySelector('.fgr-opt__n').textContent = opt.n;
        panel.appendChild(btn);
      });

      var label = root.querySelector('[data-fgr-select-label]');
      if (label) label.textContent = current === ALL ? cfg.all : current;
      root.classList.toggle('is-filtered', current !== ALL);
    });
  };

  Board.prototype.closeSelects = function (except) {
    var list = this.board.querySelectorAll('[data-fgr-select]');
    for (var i = 0; i < list.length; i++) {
      if (list[i] === except) continue;
      list[i].classList.remove('is-open');
      var t = list[i].querySelector('[data-fgr-select-toggle]');
      var p = list[i].querySelector('[data-fgr-select-panel]');
      if (t) t.setAttribute('aria-expanded', 'false');
      if (p) p.hidden = true;
    }
  };

  Board.prototype.bind = function () {
    var self = this;

    this.board.addEventListener('click', function (e) {
      var seg = e.target.closest('[data-fgr-view]');
      if (seg) {
        self.view = seg.getAttribute('data-fgr-view');
        self.board.querySelectorAll('[data-fgr-view]').forEach(function (b) {
          var on = b === seg;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        self.apply();
        return;
      }

      var toggle = e.target.closest('[data-fgr-select-toggle]');
      if (toggle) {
        var root = toggle.closest('[data-fgr-select]');
        var panel = root.querySelector('[data-fgr-select-panel]');
        var open = !root.classList.contains('is-open');
        self.closeSelects(root);
        root.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
        return;
      }

      var opt = e.target.closest('.fgr-opt');
      if (opt) {
        var host = opt.closest('[data-fgr-select]');
        var key = host.getAttribute('data-fgr-select');
        self[key] = opt.getAttribute('data-value');

        host.querySelectorAll('.fgr-opt').forEach(function (o) {
          var on = o === opt;
          o.classList.toggle('is-active', on);
          o.setAttribute('aria-selected', on ? 'true' : 'false');
        });

        var label = host.querySelector('[data-fgr-select-label]');
        if (label) label.textContent = opt.querySelector('.fgr-opt__text').textContent;
        host.classList.toggle('is-filtered', self[key] !== ALL);

        self.closeSelects(null);
        self.apply();
      }
    });

    this.empty.addEventListener('click', function (e) {
      if (!e.target.closest('.fgr-empty__btn')) return;
      self.reset();
    });

    document.addEventListener('click', function (e) {
      if (!self.board.contains(e.target)) self.closeSelects(null);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') self.closeSelects(null);
    });
  };

  Board.prototype.reset = function () {
    this.serie = ALL;
    this.line = ALL;

    var self = this;
    this.board.querySelectorAll('[data-fgr-select]').forEach(function (host) {
      var key = host.getAttribute('data-fgr-select');
      var all = key === 'serie' ? self.labels.allSeries : self.labels.allLines;
      host.classList.remove('is-filtered');
      var label = host.querySelector('[data-fgr-select-label]');
      if (label) label.textContent = all;
      host.querySelectorAll('.fgr-opt').forEach(function (o) {
        var on = o.getAttribute('data-value') === ALL;
        o.classList.toggle('is-active', on);
        o.setAttribute('aria-selected', on ? 'true' : 'false');
      });
    });

    this.apply();
  };

  Board.prototype.apply = function () {
    var self = this;
    var shown = 0;
    var liveTotal = 0;

    this.items.forEach(function (item) {
      if (!item.sold) liveTotal++;

      var ok =
        (self.view === 'all' || !item.sold) &&
        (self.serie === ALL || item.serie === self.serie) &&
        (self.line === ALL || item.line === self.line);

      item.el.classList.toggle('fgr-hidden', !ok);
      if (ok) shown++;
    });

    this.empty.hidden = shown > 0;

    var live = this.board.querySelector('[data-fgr-count-live]');
    var all = this.board.querySelector('[data-fgr-count-all]');
    if (live) live.textContent = liveTotal;
    if (all) all.textContent = this.items.length;
  };

  ready(function () {
    var tools = document.querySelector('[data-fgr-tools]');
    if (tools) new Board(tools).init();
  });
})();